import { Link } from "react-router-dom"
import styled from "styled-components"
import { themeDropdown, topbarDropdown, userRoleDropdown } from "../../../../features/layout/layoutSlice"
import { useDispatch, useSelector } from "react-redux"
import { showModal } from "../../../../features/modal/modalSlice"
import firmaLogoLight from "../../../../images/svg/topYogunluk/egeyurt-light.svg"
import firmaLogoDark from "../../../../images/svg/topYogunluk/egeyurt-dark.svg"

const Contaniner = styled.div`
    width: 250px;
    height: auto;
    background-color: var(--color-light);
    position: absolute;
    top: 70px;
    left: 0px;
    z-index: 20;
    border-radius: 10px;
    padding: 15px 30px;
    display: flex;
    flex-direction: column;
    cursor: initial;
    background-color: ${({ theme }) => theme.secondaryBgColor};
    border: 1px solid${({ theme }) => theme.mainBorderColor};

    .user{
      padding: 6px 0px;
      gap: 3px;
      display: flex;
      flex-direction: column;
      .logo-box{
        margin-bottom: 5px;
        img{
          width: 100%;
          margin-bottom: 6px;
          height: 100px;
        }
      }
      .company-name {
        font-size: 16px;
        font-weight: var(--font-weight-lg);
        line-height: 19px;
        margin-bottom: 6px;
      }
      .username{
        font-size: 16px;
        font-weight: var(--font-weight-lg);
        line-height: 19px;
        margin-top: 3px;
        border-bottom: 1px solid gray;
        padding-bottom: 6px;
        }
      }

      .item{
        width: 100%;
        padding: 6px 0;
        p{
          cursor: pointer;
        }
          
        & > *{
          font-size: 16px;
          font-weight: var(--font-weight-lg);
          line-height: 18px;
          text-align: left;
          color: ${({ theme }) => theme.mainTextColor};
        }

        .pointer{
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 20px;
        }
      }
`


const TopbarUserDropdown = () => {

  const dispatch = useDispatch()
  const {themeRef } = useSelector((state)=> state.layout)
  const {topBarCompanyInfo} = useSelector((state)=> state.companyProfile)

  return (
    <Contaniner>
      <div className="user">
        {/* <div className="logo-box">
          <img src={`${process.env.REACT_APP_API_IMG_COMPANY_URI}${topBarCompanyInfo?.logo1}` || `${process.env.REACT_APP_API_IMG_COMPANY_URI}${topBarCompanyInfo?.logo2}`} alt="logo" />
        </div> */}
        <div className="company-name">{topBarCompanyInfo?.companyName}</div>
        <div className="username">{topBarCompanyInfo?.yetkiliUserName}</div>
      </div> 

      <div className="item">
        <Link onClick={()=> dispatch(topbarDropdown())} to={"/profilim/firma-bilgileri"}>Profili Görüntüleyin</Link>
      </div>
      <div className="item" onClick={()=> {dispatch(topbarDropdown()); dispatch(themeDropdown())}}>
        <div className="pointer">Tema: {themeRef === "system" ? "Cihaz Teması": themeRef === "light" ? "Açık Tema" : "Kapalı Tema"}</div>
      </div>
      <div className="item">
        <p onClick={()=> {dispatch(topbarDropdown()); dispatch(showModal("iletisimBilgileri")) }} >İletişim</p>
      </div>
      <div className="item">
        <div className="pointer" onClick={() => dispatch(showModal("logoutVerification"))}>Oturumu Kapat</div>
      </div>
    </Contaniner>
  )
}

export default TopbarUserDropdown